import { render, staticRenderFns } from "./VideoSender.vue?vue&type=template&id=68e31fa0&scoped=true&"
import script from "./VideoSender.vue?vue&type=script&lang=js&"
export * from "./VideoSender.vue?vue&type=script&lang=js&"
import style0 from "./VideoSender.vue?vue&type=style&index=0&id=68e31fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e31fa0",
  null
  
)

export default component.exports